export default __webpack_public_path__ + "static/media/indicator_carousel4.52331d7d.png";